import styled from 'styled-components';

export const ContainerResume = styled.div`
  width: 100vw;
  display: flex;
  align-items: center;
  flex: none;
  flex-direction: column;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex: none;
  font-family: 'Libre Franklin', sans-serif;
  width: 89.333vw;
  align-items: center;
  padding-top: 3vw;
  p {
    font-weight: 400;
    font-size: 3.733vw;
    background-color: transparent;
  }
`;

export const CartIcon = styled.img`
  width: 3.885vw;
  height: 3.466vw;
  margin: 0 1.52vw 0 0;
`;

export const ContainerInfo = styled.div`
  border: solid #ededed 0.266vw;
  border-radius: 2.66vw;
  width: 89.33vw;
  height: auto;
  margin-top: 4.26vw;
  padding: 5.3vw 4.53vw 5.3vw 4.53vw;
  box-sizing: border-box;
`;

export const ContainerHourAddress = styled.div`
  margin-top: 3.73vw;
  display: flex;
  flex-direction: column;
`;

export const ContainerRow = styled.div<{ gap: string }>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap};
  margin-top: 1.3vw;
  align-items: center;
`;

export const TextInfo = styled.p`
  font-family: 'Libre Franklin', sans-serif;
  font-size: 3.2vw;
  font-weight: 700;
`;

export const IconClock = styled.img`
  width: 3.2vw;
  height: 3.46vw;
`;

export const IconOnline = styled.img`
  width: 4vw;
  height: 3.4vw;
`;

export const TextMeet = styled.p`
  font-size: 3.2vw;
  font-family: 'Libre Franklin', sans-serif;
  margin-top: 1.3vw;
  font-weight: 500;
  margin-left: 6.13vw;
`;

export const IconFaceToFace = styled.img`
  width: 3.73vw;
  height: 3.46vw;
`;

export const TextAddress = styled.p`
  font-size: 3.2vw;
  font-family: 'Libre Franklin', sans-serif;
  font-weight: 500;
  margin-top: 1.3vw;
  margin-left: 6.13vw;
`;

export const ContainerService = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  p {
    font-size: 5.3vw;
    font-family: 'Libre Franklin', sans-serif;
    font-weight: 700;
    width: 65.8vw;
  }
`;

export const IconCase = styled.img`
  width: 4.26vw;
  height: 4.26vw;
  margin-right: 2.13vw;
`;

export const ArrowUpIcon = styled.img<{ transform: string }>`
  width: 3.8vw;
  height: 4.424vw;
  right: 1.77vw;
  transform: ${(props) => props.transform};
  position: absolute;
`;

export const ContainerConsultant = styled.div`
  width: 89.33vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2.66vw;
  margin-top: 6.1vw;
`;

export const ImageConsultant = styled.img`
  width: 11.2vw;
  height: 11.2vw;
  border-radius: 50vw;
`;

export const ContainerName = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-family: 'Libre Franklin', sans-serif;
    font-weight: 500;
    font-size: 3.2vw;
  }
  h1 {
    font-family: 'Libre Franklin', sans-serif;
    font-weight: 700;
    font-size: 4vw;
  }
`;

export const ContainerCoupon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 89.33vw;
  justify-content: space-between;
`;

export const InputCoupon = styled.input`
  width: 60vw;
  height: 13.3vw;
  border: solid #c7c7c7 0.266vw;
  padding-left: 3.73vw;
  border-radius: 2.66vw;
  box-sizing: border-box;
`;

export const ButtonDiscount = styled.button`
  width: 25.1vw;
  background-color: #000000;
  color: #ffffff;
  height: 13.3vw;
  font-family: 'Outfit', sans-serif;
  font-size: 3.73vw;
  font-weight: 700;
  border: none;
  align-items: center;
  justify-content: center;
  border-radius: 2.66vw;
`;

export const PurchaseCheckout = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
`;

export const ContainerTotal = styled.div`
  display: flex;
  flex: none;
  width: 89.333vw;
  align-items: flex-start;
  font-family: 'Libre Franklin', sans-serif;
  justify-content: space-between;
  h4 {
    font-size: 3.733vw;
    font-weight: 400;
    background-color: transparent;
  }
`;

export const ContainerValues = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 0.266vw;
  font-family: 'Libre Franklin', sans-serif;
  align-items: flex-end;
  background-color: transparent;
  span {
    text-decoration: line-through;
    font-size: 3.733vw;
    font-weight: 400;
    background-color: transparent;
  }
  p {
    font-size: 5.866vw;
    font-weight: 700;
    background-color: transparent;
  }
`;

export const GrayLine = styled.div`
  height: 0.266vw;
  background-color: #c7c7c7;
  width: 89.3vw;
  margin-top: 5.3vw;
  margin-bottom: 5.3vw;
`;
